export default "__VITE_ASSET__CvviXUWs__"